import { Product, ProductsService } from '../api';

interface ProductsProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: Product[]; total: number }>;
  create: (resource: string, params: any) => Promise<{ data: Product }>;
  getOne: (resource: string, params: any) => Promise<{ data: Product }>;
  update: (resource: string, params: any) => Promise<{ data: Product }>;
  delete: (resource: string, params: any) => Promise<{ data: boolean }>;
  getMany: (resource: string, params: any) => Promise<{ data: Product[] }>;
  getManyReference: (
    resource: string,
    params: any
  ) => Promise<{ data: Product[] }>;
  updateMany: (resource: string, params: any) => Promise<{ data: Product[] }>;
  deleteMany: (resource: string, params: any) => Promise<{ data: Product[] }>;
}

export const productsDataProvider: ProductsProviderResource = {
  getList: async (resource, params) => {
    const { pagination } = params;
    const data = await ProductsService.listProducts(
      pagination.page,
      pagination.perPage,
      false
    );
    if (data.items) {
      return {
        data: data.items,
        total: data.items.length,
      };
    }
    return {
      data: [],
      total: 0,
    };
  },
  getOne: async (resource, params) => {
    const { id } = params;
    const product = await ProductsService.getProduct(id);
    return {
      data: product,
    };
  },
  create: async (resource, params) => {
    const product = await ProductsService.createProduct(params.data);
    return {
      data: product,
    };
  },
  update: async (resource, params) => {
    const { id, data } = params;
    const product = await ProductsService.updateProduct(id, data);
    return {
      data: product,
    };
  },
  delete: async (resource, params) => {
    const { id } = params;
    await ProductsService.deleteProduct(id);
    return { data: true };
  },
  getMany: async (resource, params) => {
    const { ids } = params;
    const products = await Promise.all(
      ids.map((id: string) => ProductsService.getProduct(id))
    );
    return {
      data: products,
    };
  },
  getManyReference: async (resource, params) => {
    const { pagination } = params;
    const data = await ProductsService.listProducts(
      pagination.page,
      pagination.perPage
    );

    return {
      data: data.items || [],
    };
  },
  updateMany: async (resource, params) => {
    const { ids, data } = params;
    const products = await Promise.all(
      ids.map((id: string) => ProductsService.updateProduct(id, data))
    );
    return {
      data: products,
    };
  },
  deleteMany: async (resource, params) => {
    const { ids } = params;
    await Promise.all(
      ids.map((id: string) => ProductsService.deleteProduct(id))
    );
    return {
      data: [],
    };
  },
};
